module.exports = __webpack_public_path__ + "img/banner_2.49c0fced.png";